import { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Alert, Button, Col, Form, FormFeedback, FormGroup, Label, Modal, Row } from 'reactstrap';
import { IGroup, IUser } from 'src/services/types';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { updateGroupUser, createGroup, getGroups, updateGroup, removeGroupUser } from 'src/services/group-service';

interface IProps {
    show: boolean;
    onClose: () => void;
    item: IUser;
    onRefresh: () => void;
} 
export const GroupModal = ({ show, onClose, item, onRefresh }: IProps) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [groupOptions, setGroupOptions] = useState<IGroup[]>([]);

    const fetchGroups = async () => {
        setLoading(true);
        const res = await getGroups();
        setLoading(false);
        if (res.result === 'ok') {
            setGroupOptions(res.data);
        } else {
            toast(res.message, { type: 'error'});
        }
    }

    const formik = useFormik({
        enableReinitialize: true,

        initialValues: {
            groupId: item?.group?.id || '',
        },
        validationSchema: Yup.object().shape({
            groupId: Yup.string().required("Please select group"),
        }),
        onSubmit: (values) => {
            onUpdate(values?.groupId);
        }
    });

    const onUpdate = async (groupId: string)=> {
        setLoading(true);
        setErrorMessage('');
        const res = await updateGroupUser(item?.id, groupId);
        setLoading(false);
        if (res.result === 'ok') {
            toast( item?.group?.id ? 'Group updated successfully' : 'Group assigned successfully', { type: 'success'});
            onRefresh();
            onClose();
        } else {
            setErrorMessage(res.message);
            console.log('error:', res.message);
        }
    }

    const onRemove = async (groupId: string) => {
        setLoading(true);
        setErrorMessage('');
        const res = await removeGroupUser(item?.id!, groupId);
        setLoading(false);
        if (res.result === 'ok') {
            toast(res?.message ?? 'Group removed successfully', { type: 'success'});
            onRefresh();
            onClose();
        } else {
            setErrorMessage(res.message);
            console.log('error:', res.message);
        }
    }

    useEffect(() => {
        if(show) {
            formik.resetForm();
        }
    }, [show]);

    useEffect(() => {
        fetchGroups();
    }, []);

  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
        className=''
    >
        {
            <div style={{position: 'relative', backgroundColor: loading ? '#D8C8B8' : '#fff' }}>
                <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                        Group
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onClose}
                        aria-label="Close"
                    ></button>
                </div>
                <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            formik.handleSubmit();
                            return false;
                        }}
                >
                    <div className="modal-body">
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="settingTypeId">Select a Group</Label>
                                    
                                    <select 
                                        className={`form-control ${ formik.touched && formik.errors.groupId ? ' is-invalid' : ''}`}
                                        name="groupId"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.groupId || ""}
                                        style={{ backgroundColor: '#fff'}}
                                    >
                                        <option value={''}>Select a option</option>
                                        {
                                            groupOptions.map((group, index) => (
                                                <option key={index} value={group.id}>{group.name}</option>
                                            ))
                                        }
                                    </select>
                                    { formik.touched && formik.errors.groupId ? (
                                        <FormFeedback type="invalid">{formik.errors.groupId}</FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        
                        <Row>
                            <Alert color="danger" isOpen={errorMessage !== ''} toggle={() => setErrorMessage('')}>
                                {errorMessage}
                            </Alert>
                        </Row>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                        {
                            item?.group?.id ? 
                            // <Button color="danger-light" type="button" onClick={() => onUpdate(item?.group?.id || '')}>
                            //     Remove Group
                            // </Button>
                            <button
                                type="button"
                                className="btn btn-soft-danger waves-effect waves-light"
                                onClick={(e) => (onRemove(item?.group?.id || ''), e.currentTarget.blur())}
                            >
                                <span>Remove group</span>
                            </button>
                            : null
                        }
                        
                        <Button color="primary" type="submit" className='waves-effect waves-light'>
                                {item?.group?.id ? 'Update' : 'Assign'} group
                        </Button>
                    </div>
                </Form>
                {
                    loading ? 
                    <div 
                        className='d-flex justify-content-center align-items-center rounded my-2 mx-2' 
                        style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(253, 252, 255, 0.75)'}}
                    >
                         <div className="spinner-border text-primary" role="status">
                        </div>
                        <span className="text-primary fs-5 mx-2">
                            {item?.group?.id ? 'Updating group...' : 'Assigning group...'}
                        </span>
                    </div>
                    : null
                }
            </div>   
        }
    </Modal>
  )
}
